module.exports = __webpack_public_path__ + "img/01_full.cf349a1e.jpg";